<ion-content class="ion-padding">
    <div class="max-page-width">
        <ion-card mode="ios" color="primary" class="dashboard-statistic-title">
            <ion-card-content class="ion-no-padding">
                <ion-row>
                    <ion-col size="auto" class="border-right">
                        <div class="col-data">
                            <div class="label">{{ 'dashboard.cycle' | translate }}</div>
                            <ion-item lines="none" mode="ios" class="select-cycle">
                                <ion-button class="btn-select-cycle" mode="ios" fill="outline" (click)="selectCycle()">
                                    {{ selectedCycle?.name ? selectedCycle?.name : ('generic.selectCycle' | translate) }}
                                </ion-button>
                            </ion-item>
                        </div>
                    </ion-col>
                    <ion-col size="7" size-md="">
                        <div class="col-data">
                            <div class="label">{{ 'dashboard.assessmentStart' | translate }}</div>
                            <h3>{{ processes && processes.length > 0 ? (processes[0].startsAt | date:'dd/MM/yyyy') : '--' }}</h3>
                        </div>
                    </ion-col>

                    <ion-col size="6" size-md="">
                        <div class="col-data">
                            <div class="label">{{ 'generic.evaluee' | translate }}</div>
                            <h3>{{ userInfo?.name }}</h3>
                        </div>
                    </ion-col>
                    <ion-col size="6" size-md="" *ngIf="userInfo?.lineManager">
                        <div class="col-data">
                            <div class="label">{{ 'dashboard.lineManager' | translate }}</div>
                            <h3>{{ userInfo?.lineManager?.name }}</h3>
                        </div>
                    </ion-col>

                    <!-- <ion-col size="12" size-lg="5" *ngIf="nextProcess" >
                      <ion-row>
                        <ion-col size="12" size-lg="">
                          <div class="col-data">
                            <div class="label">
                              {{ 'dashboard.assessmentStatus' | translate }}
                            </div>
                            <div class="progress-bar-container">
                              <div class="prohress-bar">
                                <span style="width:17%"></span>
                              </div>
                              <div class="progress-bar-status">17%</div>
                            </div>
                          </div>
                        </ion-col>
          
                        <ion-col size="12" size-lg="12">
                          <div class="col-data button-right task">
                            <div class="slot-left">
                              <div class="label">
                                {{ 'dashboard.nextTaskBtn' | translate }}
                              </div>
                              <h3>{{ getText(nextProcess.title, 'title') }}</h3>
                            </div>
                            <ion-button color="secondary" mode="ios" size="small"
                              (click)="triggerProcessAction(nextProcess.processType, selectedCycleId)" >
                              {{ 'dashboard.goToTask' | translate }}
                            </ion-button>
                          </div>
                        </ion-col>
                      </ion-row>
                    </ion-col> -->
                </ion-row>
            </ion-card-content>
        </ion-card>
        <div class="btg-core-principles" *ngIf="(showDashboardWelcome && welcomeMessage) 
                                                || corePrinciples?.length > 0 
                                                || leadershipPrinciples?.length > 0">
            <ng-container *ngIf="showDashboardWelcome && welcomeMessage">
                <ion-card class="card-custom">
                    <ion-card-content>
                        <ion-item mode="ios" detail="false" lines="none">
                            <ion-label style="font-size: 14px; white-space: pre-line; line-height: 1.2" [innerHtml]="welcomeMessage"> </ion-label>
                        </ion-item>
                    </ion-card-content>
                </ion-card>
            </ng-container>
            <ng-container *ngIf="showCorePrinciples && loadedClycle">
                <app-core-principles [corePrinciples]="corePrinciples" [leadershipPrinciples]="leadershipPrinciples"></app-core-principles>
            </ng-container>
        </div>

        <ion-row lrm>
            <ion-col size="12" size-lg="6">
                <ng-container *ngIf="processes">
                    <app-assessment-process
                        [processes]="processes"
                        [userAttributes]="userAttributes"
                        [cycleId]="selectedCycleId"
                        (triggerProcessAction)="triggerProcessAction($event.processType, selectedCycleId, $event.cycleProcessConfigId)"
                    ></app-assessment-process>
                </ng-container>
            </ion-col>
            <ion-col size="12" size-lg="6">
                <ng-container *ngIf="userInfo?.manager || isHrOrAdmin">
                    <ion-item color="lightgray" mode="ios" detail="false" lines="none" class="see-your-team-progress" (click)="viewTeamProgress()">
                        <ion-label color="primary"> {{ 'dashboard.viewTeamProgress' | translate }} </ion-label>
                        <ion-icon color="primary" size="small" slot="end" class="bp-arrow-right"></ion-icon>
                    </ion-item>
                </ng-container>

                <ng-container *ngIf="!hideReports && (userInfo?.manager || isHrOrAdmin || hasReportAccess)">
                    <ion-item color="lightgray" mode="ios" detail="false" lines="none" class="see-your-team-progress" (click)="viewReports()">
                        <ion-label color="primary"> {{ 'dashboard.Reports' | translate }} </ion-label>
                        <ion-icon color="primary" size="small" slot="end" class="bp-arrow-right"></ion-icon>
                    </ion-item>
                </ng-container>

                <ion-item color="lightgray" mode="ios" detail="false" lines="none" class="see-your-team-progress" (click)="viewNotepad()">
                    <ion-label color="primary"> {{ 'notepad.notepad' | translate }} </ion-label>
                    <ion-icon color="primary" size="small" slot="end" class="bp-arrow-right"></ion-icon>
                </ion-item>

                <ion-item *ngIf="hrChannel" color="lightgray" mode="ios" detail="false" lines="none" class="see-your-team-progress" (click)="viewHrChannel()">
                    <ion-label color="primary"> {{ 'hr-channel.title' | translate }} </ion-label>
                    <ion-icon color="primary" size="small" slot="end" class="bp-arrow-right"></ion-icon>
                </ion-item>

                <a *ngIf="tutorialMenu" class="tutorial-link"
                   [href]="tutorialPath" target="_new">
                    <ion-item color="lightgray" mode="ios" detail="false" lines="none" class="see-your-team-progress">
                        <ion-label color="primary">
                            {{ 'dashboard.Tutorial' | translate }}
                        </ion-label>
                        <ion-icon color="primary" size="small" slot="end" class="bp-arrow-right"></ion-icon>
                    </ion-item>
                </a>

                <ng-container *ngIf="goalsProgress && goalsProgress.length > 0">
                    <app-goals-progress [cycleId]="selectedCycleId" [processes]="goalsProgress" (reloadProgresses)="reloadProgresses()"></app-goals-progress>
                </ng-container>

                <ng-container>
                    <app-okr></app-okr>
                </ng-container>

                <ng-container>
                    <app-feedback-status></app-feedback-status>
                </ng-container>

                <ng-container *ngIf="freeEvaluationSummary && canAddNewFreeEvaluation(freeEvaluationSummary)">
                    <ion-card class="card-custom">
                        <ion-card-header has-button>
                            <ion-card-title> {{ 'dashboard.freeEvaluation' | translate }} </ion-card-title>
                            <ion-button mode="ios" color="secondary" (click)="triggerProcessAction(ProcessType.FreeEvaluationMidYear, selectedCycleId)">
                                {{ 'dashboard.newEvaluationBtn' | translate }}
                            </ion-button>
                        </ion-card-header>
                        <ion-card-content class="ion-no-padding">
                            <ion-item mode="ios" detail="false" lines="none" class="evaluations">
                                <ion-label color="title"> {{ freeEvaluationSummary.drafts }} {{ 'dashboard.savedEvaluations' | translate }} </ion-label>
                            </ion-item>
                            <ion-item mode="ios" detail="false" lines="none" class="evaluations">
                                <ion-label color="title" style="font-size: 14px" noWhiteSpace> {{ 'dashboard.freeEvaluationDescription' | translate }} </ion-label>
                            </ion-item>
                        </ion-card-content>
                    </ion-card>
                </ng-container>

                <ng-container *ngIf="freeEvaluationSummary && canAddNewFreeEvaluationEndYear(freeEvaluationSummary)">
                    <ion-card class="card-custom">
                        <ion-card-header has-button>
                            <ion-card-title> {{ 'dashboard.freeEvaluationEndYear' | translate }} </ion-card-title>
                            <ion-button mode="ios" color="secondary" (click)="triggerProcessAction(ProcessType.FreeEvaluationEndYear, selectedCycleId)">
                                {{ 'dashboard.newEvaluationBtn' | translate }}
                            </ion-button>
                        </ion-card-header>
                        <ion-card-content class="ion-no-padding">
                            <ion-item mode="ios" detail="false" lines="none" class="evaluations">
                                <ion-label color="title"> {{ freeEvaluationSummary.endYearSummary.drafts }} {{ 'dashboardEvaluations' | translate }} </ion-label>
                            </ion-item>
                            <ion-item mode="ios" detail="false" lines="none" class="evaluations">
                                <ion-label color="title" style="font-size: 14px" noWhiteSpace> {{ 'dashboard.freeEvaluationDescription' | translate }} </ion-label>
                            </ion-item>
                        </ion-card-content>
                    </ion-card>
                </ng-container>

                <ng-container *ngIf="('dashboard.assessmentInstructions' | translate) != 'dashboard.assessmentInstructions'">
                    <ion-card class="card-custom" *ngIf="videoUrl">
                        <ion-card-header has-button *ngIf="hideVideoInstructionsLabel">
                            <ion-card-title> {{ 'dashboard.assessmentInstructions' | translate | uppercase }} </ion-card-title>
                            <br /><br />
                        </ion-card-header>
                        <ion-card-content class="ion-no-padding">
                            <ion-item mode="ios" detail="false" lines="none" class="evaluations">
                                <iframe
                                    width="100%"
                                    height="300"
                                    allowfullscreen
                                    frameborder="0"
                                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                                    [src]="videoUrl | safeUrl"
                                ></iframe>
                            </ion-item>
                            <br/>
                        </ion-card-content>
                    </ion-card>
                </ng-container>
            </ion-col>
        </ion-row>
    </div>
</ion-content>